export type ComicCategory = {
  slug: string;
  name: string;
  en: string;
  tagline: string;
  description: string;
  tags: string[];
  banner: string;
};

export type Comic = {
  id: string;
  title: string;
  category: string;
  tags: string[];
  description: string;
  cover: string;
  author: string;
  status: '连载中' | '已完结';
  rating: number;
  views: string;
  chapters: number;
  latestChapter: string;
  updateTime: string;
  featured?: boolean;
  hot?: boolean;
};

export const categories: ComicCategory[] = [
  {
    slug: 'shenye',
    name: '深夜档',
    en: '深夜剧场',
    tagline: '更新最快的剧情追更专区',
    description: '专门收录在深夜更新的都市诡异、悬疑烧脑与暗黑剧情漫画。每天都有新章上线，剧情带感、反转不断，适合夜猫子们的追更日常。',
    tags: ['都市诡异', '悬疑烧脑', '深夜剧场', '烧脑反转'],
    banner: 'https://readdy.ai/api/search-image?query=dark%20noir%20city%20at%20midnight%20with%20foggy%20street%20lanterns%20and%20crimson%20red%20glow%20manga%20background%20illustration%2C%20suspenseful%20atmosphere%2C%20gritty%20ink%20texture&width=1600&height=500&seq=cat-shenye-banner&orientation=landscape',
  },
  {
    slug: 'zhongweikou',
    name: '重口味',
    en: '硬核猎奇',
    tagline: '画风大胆的血腥猎奇精选',
    description: '为敢于直面黑暗的读者准备。血浆恐怖、猎奇心理、极端人性题材一网打尽，画风大胆冲击力强，剧情同样深刻耐读。',
    tags: ['血浆恐怖', '猎奇心理', '硬核暗黑', '感官冲击'],
    banner: 'https://readdy.ai/api/search-image?query=dark%20horror%20comic%20artwork%20with%20dripping%20crimson%20paint%20and%20abstract%20dark%20silhouettes%20in%20shadow%2C%20heavy%20gritty%20brutalist%20manga%20style%2C%20high%20contrast%20moody%20lighting&width=1600&height=500&seq=cat-zhongweikou-banner&orientation=landscape',
  },
  {
    slug: 'anheixiang',
    name: '暗黑向',
    en: '暗黑美学',
    tagline: '人性深渊与暗黑美学',
    description: '聚焦人性最幽暗的角落。黑暗人性、暗黑格斗、黑暗奇幻交织，在层层压迫的剧情中探寻光明，是暗黑美学爱好者的精神栖所。',
    tags: ['黑暗人性', '暗黑格斗', '黑暗奇幻', '人性深渊'],
    banner: 'https://readdy.ai/api/search-image?query=dark%20fantasy%20gothic%20castle%20silhouette%20under%20crimson%20moon%20with%20ravens%20and%20mist%20manga%20artwork%2C%20moody%20eerie%20atmosphere%2C%20deep%20shadow%20and%20amber%20highlight&width=1600&height=500&seq=cat-anheixiang-banner&orientation=landscape',
  },
];

export const comics: Comic[] = [
  {
    id: 'wuye-dangan',
    title: '午夜档案',
    category: 'shenye',
    tags: ['都市诡异', '悬疑烧脑', '深夜剧场'],
    description: '凌晨三点，档案室的门总会自己打开。每一份无人认领的档案背后，都藏着一桩被时间掩埋的诡异旧案。接手午夜档案室的青年调查员，在一次次解密中逐渐意识到——有些秘密，根本不该被翻出来。',
    cover: 'https://readdy.ai/api/search-image?query=dark%20suspense%20manga%20comic%20cover%20illustration%20of%20a%20dim%20archive%20room%20with%20filing%20cabinets%20and%20a%20single%20desk%20lamp%20casting%20long%20shadows%2C%20noir%20moody%20lighting%20with%20crimson%20red%20accents%2C%20gritty%20ink%20texture%2C%20mysterious%20atmosphere&width=600&height=800&seq=comic-wuye-dangan&orientation=portrait',
    author: '冷雾',
    status: '连载中',
    rating: 4.8,
    views: '128万',
    chapters: 87,
    latestChapter: '第87话 回廊尽头',
    updateTime: '今日更新',
    featured: true,
    hot: true,
  },
  {
    id: 'wusheng-shenyuan',
    title: '无声深渊',
    category: 'shenye',
    tags: ['都市诡异', '悬疑烧脑', '烧脑反转'],
    description: '这座城市的第七码头，夜夜有怪声传出却无人报案。潜水员老周在下潜时发现，码头下的沉船里，塞满了整整一船会说话的镜子。谁在黑暗里低语？声音又是谁的？',
    cover: 'https://readdy.ai/api/search-image?query=dark%20underwater%20horror%20manga%20comic%20cover%20with%20a%20sinking%20shipwreck%20in%20deep%20dark%20ocean%20and%20faint%20crimson%20light%20rays%2C%20moody%20noir%20atmosphere%2C%20gritty%20ink%20texture%2C%20eerie%20mysterious%20tones&width=600&height=800&seq=comic-wusheng-shenyuan&orientation=portrait',
    author: '潮汐',
    status: '连载中',
    rating: 4.7,
    views: '96万',
    chapters: 63,
    latestChapter: '第63话 镜中话事人',
    updateTime: '昨日更新',
    featured: true,
  },
  {
    id: 'anri-diyu',
    title: '暗日低语',
    category: 'shenye',
    tags: ['深夜剧场', '悬疑烧脑', '都市诡异'],
    description: '当太阳不再升起，城市陷入永夜。收音机里却循环播放着来自「昨天」的节目预告。主播的声音一天比一天年轻，而每一位听完整档节目的人，都会在次日清晨消失。',
    cover: 'https://readdy.ai/api/search-image?query=dark%20apocalyptic%20manga%20comic%20cover%20with%20a%20lone%20radio%20broadcast%20booth%20under%20an%20eclipsed%20black%20sun%20and%20crimson%20horizon%2C%20moody%20noir%20lighting%2C%20gritty%20ink%20texture%2C%20ominous%20atmosphere&width=600&height=800&seq=comic-anri-diyu&orientation=portrait',
    author: '白昼鱼',
    status: '连载中',
    rating: 4.6,
    views: '74万',
    chapters: 41,
    latestChapter: '第41话 昨日电台',
    updateTime: '今日更新',
    hot: true,
  },
  {
    id: 'xuezhi-qiye',
    title: '血色契约',
    category: 'zhongweikou',
    tags: ['血浆恐怖', '猎奇心理', '硬核暗黑'],
    description: '一份流传在老城区地下的「血色契约」，签下它的人能获得想要的任何东西，代价却是被一步步拖入深渊。侦探林砚循着血迹追查，却发现契约上的名字，正是他自己。',
    cover: 'https://readdy.ai/api/search-image?query=dark%20bloody%20pact%20manga%20comic%20cover%20with%20a%20sealed%20red%20wax%20contract%2C%20dripping%20blood%20and%20black%20quill%20feather%20on%20dark%20background%2C%20horror%20brutalist%20style%2C%20crimson%20red%20dominating%20moody%20lighting&width=600&height=800&seq=comic-xuezhi-qiye&orientation=portrait',
    author: '墨痕',
    status: '连载中',
    rating: 4.9,
    views: '203万',
    chapters: 119,
    latestChapter: '第119话 逆名的代价',
    updateTime: '今日更新',
    featured: true,
    hot: true,
  },
  {
    id: 'qiu-long',
    title: '囚笼',
    category: 'zhongweikou',
    tags: ['猎奇心理', '感官冲击', '硬核暗黑'],
    description: '七名陌生人醒来时，发现自己被关在一座没有出口的白色牢笼里。规则只有一条：每当有人试图逃离，牢笼就会「吞掉」他记忆中最珍贵的一段。随着记忆被剥离，真相的轮廓却愈发狰狞。',
    cover: 'https://readdy.ai/api/search-image?query=dark%20psychological%20thriller%20manga%20comic%20cover%20with%20figures%20trapped%20inside%20a%20looming%20white%20cage%20in%20black%20void%2C%20blood%20red%20light%20seeping%20through%20bars%2C%20horror%20gritty%20ink%20style%2C%20claustrophobic%20atmosphere&width=600&height=800&seq=comic-qiu-long&orientation=portrait',
    author: '废土',
    status: '连载中',
    rating: 4.7,
    views: '152万',
    chapters: 74,
    latestChapter: '第74话 白色契约',
    updateTime: '昨日更新',
    featured: true,
  },
  {
    id: 'shihun-zhi-xiang',
    title: '噬魂之巷',
    category: 'zhongweikou',
    tags: ['血浆恐怖', '猎奇心理', '感官冲击'],
    description: '老城区的「噬魂巷」，入夜后会有黑影沿着墙根爬行，专挑落单的人下手。据传被噬魂巷吞掉的人，会在黎明时分以「空壳」的姿态出现在巷口。猎人赵拾为查清妹妹的下落，孤身踏入这条巷子。',
    cover: 'https://readdy.ai/api/search-image?query=dark%20urban%20horror%20manga%20comic%20cover%20with%20a%20shadowy%20alley%20between%20old%20buildings%20and%20an%20ominous%20black%20silhouette%20creeping%20along%20the%20wall%2C%20crimson%20red%20glow%2C%20gritty%20noir%20ink%20texture%2C%20menacing%20atmosphere&width=600&height=800&seq=comic-shihun-zhi-xiang&orientation=portrait',
    author: '夜半针',
    status: '已完结',
    rating: 4.8,
    views: '187万',
    chapters: 96,
    latestChapter: '第96话 完结·巷口',
    updateTime: '已完结',
    hot: true,
  },
  {
    id: 'jiuzhi-mulu',
    title: '禁忌目录',
    category: 'zhongweikou',
    tags: ['猎奇心理', '硬核暗黑', '感官冲击'],
    description: '古籍修复师偶然得到一册《禁忌目录》，翻开的人会被诅咒，除非按目录记载的仪式完成「等价交换」。目录的条目每一夜都在变化，而它最新记载的条目，竟写着修复师自己的名字。',
    cover: 'https://readdy.ai/api/search-image?query=dark%20occult%20manga%20comic%20cover%20of%20an%20ancient%20forbidden%20tome%20with%20blood%20seal%20and%20glowing%20red%20runes%20in%20a%20dim%20archive%20chamber%2C%20gothic%20horror%20style%2C%20moody%20crimson%20and%20shadow%20lighting&width=600&height=800&seq=comic-jiuzhi-mulu&orientation=portrait',
    author: '烛火',
    status: '连载中',
    rating: 4.6,
    views: '88万',
    chapters: 52,
    latestChapter: '第52话 倒计时条目',
    updateTime: '今日更新',
  },
  {
    id: 'huijin-huisheng',
    title: '灰烬回声',
    category: 'anheixiang',
    tags: ['黑暗人性', '人性深渊', '暗黑格斗'],
    description: '一场大火烧掉了整座工业城。幸存者们在废墟上建立新的秩序，却发现每当有人重新点燃炉火，灰烬里就会传来逝者生前的回声，指引着通往过去真相的路。',
    cover: 'https://readdy.ai/api/search-image?query=dark%20post-apocalyptic%20manga%20comic%20cover%20with%20a%20ruined%20industrial%20city%20and%20rising%20amber%20ember%20light%20from%20a%20single%20burning%20furnace%2C%20gritty%20noir%20ink%20style%2C%20moody%20dark%20humanity%20theme&width=600&height=800&seq=comic-huijin-huisheng&orientation=portrait',
    author: '余烬',
    status: '连载中',
    rating: 4.7,
    views: '112万',
    chapters: 68,
    latestChapter: '第68话 炉火的记忆',
    updateTime: '昨日更新',
    featured: true,
  },
  {
    id: 'jiexingzhe-shouji',
    title: '夜行者手记',
    category: 'anheixiang',
    tags: ['黑暗人性', '暗黑格斗', '人性深渊'],
    description: '只在深夜行动的神秘「夜行者」，专门清理这座城市里无人敢碰的黑暗交易。他在日记里记录每一次以暴制暴的猎杀，也记录着自己被复仇啃噬得支离破碎的人性。',
    cover: 'https://readdy.ai/api/search-image?query=dark%20vigilante%20manga%20comic%20cover%20of%20a%20hooded%20figure%20standing%20on%20a%20rainy%20rooftop%20over%20a%20neon%20red%20city%20at%20night%2C%20gritty%20noir%20style%2C%20dark%20humanity%20theme%2C%20moody%20cinematic%20lighting&width=600&height=800&seq=comic-jiexingzhe-shouji&orientation=portrait',
    author: '守夜',
    status: '连载中',
    rating: 4.8,
    views: '165万',
    chapters: 83,
    latestChapter: '第83话 以暴制暴',
    updateTime: '今日更新',
    hot: true,
  },
  {
    id: 'changye-weiyang',
    title: '长夜未央',
    category: 'anheixiang',
    tags: ['黑暗奇幻', '人性深渊', '暗黑格斗'],
    description: '当守护人间的圣光熄灭，世界陷入没有黎明的长夜。背负诅咒的末代骑士，要用最黑暗的手段守护仅存的烛火。在所有人都背弃光明的时代，他成为了最孤独的守夜人。',
    cover: 'https://readdy.ai/api/search-image?query=dark%20fantasy%20knight%20manga%20comic%20cover%20with%20a%20solitary%20black%20armored%20knight%20holding%20a%20single%20glowing%20amber%20candle%20in%20an%20endless%20night%20field%2C%20gothic%20dark%20fantasy%20style%2C%20moody%20lighting&width=600&height=800&seq=comic-changye-weiyang&orientation=portrait',
    author: '烛骑士',
    status: '连载中',
    rating: 4.9,
    views: '221万',
    chapters: 134,
    latestChapter: '第134话 末代的烛火',
    updateTime: '今日更新',
    featured: true,
    hot: true,
  },
  {
    id: 'mizhong-ren',
    title: '镜中人',
    category: 'anheixiang',
    tags: ['黑暗人性', '悬疑烧脑', '人性深渊'],
    description: '镜子里的倒影，会比你晚半秒做出动作。起初只是令人毛骨悚然的巧合，直到镜中的「自己」第一次抢先开口，说出了你的秘密。当倒影开始操控人生，谁才是真正的本体？',
    cover: 'https://readdy.ai/api/search-image?query=dark%20mystery%20manga%20comic%20cover%20of%20a%20figure%20staring%20into%20a%20cracked%20mirror%20with%20a%20faint%20red%20duplicate%20reflection%20behind%20them%2C%20noir%20psychological%20style%2C%20gritty%20ink%20texture%2C%20unsettling%20atmosphere&width=600&height=800&seq=comic-mizhong-ren&orientation=portrait',
    author: '倒影',
    status: '已完结',
    rating: 4.6,
    views: '103万',
    chapters: 58,
    latestChapter: '第58话 完结·本体',
    updateTime: '已完结',
  },
  {
    id: 'wudu-xiong-an',
    title: '雾都凶案',
    category: 'shenye',
    tags: ['悬疑烧脑', '都市诡异', '烧脑反转'],
    description: '雾都每年入冬都会封城，而封城期间城中总会离奇出现「无面尸体」。新来的刑警不信邪，决定利用这场雾揭开连环凶案的真凶——却发现凶手似乎能在所有人的眼皮底下消失。',
    cover: 'https://readdy.ai/api/search-image?query=dark%20detective%20manga%20comic%20cover%20of%20a%20trenchcoat%20detective%20with%20collar%20up%20in%20thick%20fog%20lit%20by%20a%20dim%20red%20streetlamp%20over%20old%20city%20buildings%2C%20noir%20mystery%20style%2C%20gritty%20ink%20texture&width=600&height=800&seq=comic-wudu-xiong-an&orientation=portrait',
    author: '雾里看',
    status: '连载中',
    rating: 4.7,
    views: '139万',
    chapters: 72,
    latestChapter: '第72话 无面之影',
    updateTime: '昨日更新',
  },
  {
    id: 'diao-luo-huajuan',
    title: '堕落画卷',
    category: 'zhongweikou',
    tags: ['猎奇心理', '感官冲击', '硬核暗黑'],
    description: '一幅不断变长的古画，每过一夜画中就会多出一个被「吞没」的人影。画商之女为解开祖传画卷的诅咒，把画中人的真实身份一一比对，惊恐地发现——最后一个身影，正朝她缓缓转过身来。',
    cover: 'https://readdy.ai/api/search-image?query=dark%20gothic%20manga%20comic%20cover%20of%20an%20ancient%20ink%20scroll%20painting%20unfolding%20with%20shadowy%20human%20figures%20dissolving%20into%20blood%20red%20ink%20stains%2C%20horror%20occult%20style%2C%20moody%20dark%20lighting&width=600&height=800&seq=comic-diao-luo-huajuan&orientation=portrait',
    author: '画眉',
    status: '连载中',
    rating: 4.5,
    views: '67万',
    chapters: 45,
    latestChapter: '第45话 画中转身',
    updateTime: '今日更新',
  },
  {
    id: 'shimianzhe-jiejiao',
    title: '失眠者的街角',
    category: 'shenye',
    tags: ['都市诡异', '深夜剧场', '悬疑烧脑'],
    description: '午夜便利店门口的长椅上，总坐着一位「失眠者」。他向每个深夜买咖啡的顾客讲述自己无法入睡的原因，而每一位听完故事的人，都会在当夜做同一个噩梦。',
    cover: 'https://readdy.ai/api/search-image?query=dark%20slice%20of%20horror%20manga%20comic%20cover%20of%20a%20lonely%20convenience%20store%20bench%20under%20a%20single%20fluorescent%20red%20light%20at%20midnight%2C%20noir%20quiet%20horror%20style%2C%20gritty%20ink%20texture%2C%20melancholic%20eerie%20mood&width=600&height=800&seq=comic-shimianzhe-jiejiao&orientation=portrait',
    author: '晚灯',
    status: '连载中',
    rating: 4.6,
    views: '92万',
    chapters: 61,
    latestChapter: '第61话 长椅上的邀请',
    updateTime: '昨日更新',
  },
];

export const categoriesMap: Record<string, ComicCategory> = categories.reduce(
  (acc, c) => {
    acc[c.slug] = c;
    return acc;
  },
  {} as Record<string, ComicCategory>,
);

export const getComic = (id: string): Comic | undefined =>
  comics.find((c) => c.id === id);

export const getComicsByCategory = (slug: string): Comic[] =>
  comics.filter((c) => c.category === slug);

export const featuredComics = comics.filter((c) => c.featured);
export const hotComics = comics.filter((c) => c.hot);